import { useEventContext, useUserContext } from "src/shared/contexts";
import { isHardwareOrganizer } from "src/shared/utils/hardwareAccess";

export const useHardwareOrganizerAccess = (): boolean => {
  const { roles, isOrganizer, email } = useUserContext();
  const { hardware } = useEventContext();

  return isHardwareOrganizer(
    roles,
    isOrganizer,
    email,
    hardware.volunteersWithAccess
  );
};
